// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__w2oR9","content":"LoadingAlert_content__hZcLH"};